import { defineComponent as k, ref as y, computed as o, openBlock as S, createElementBlock as v, normalizeClass as i, createElementVNode as x, toDisplayString as f } from "vue";
import { _ as C } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const g = [
  // Layout
  "inline-flex",
  // Box
  "max-w-full",
  // Typography
  "whitespace-nowrap"
], F = [
  // Layout
  "overflow-hidden",
  // Typography
  "text-ellipsis"
], h = [
  // Layout
  "shrink"
], w = k({
  name: "OrText",
  props: {
    /**
     * Text to crop.
     */
    text: {
      type: String,
      required: !0
    },
    /**
     * The index counted from the end of the string where ellipsis will be placed.
     * Defines how many ending characters will remain visible.
     * By default, ellipsis is placed in the end of the line.
     *
     * Note: Negative values behave same as corresponding positives still counting from the end of the line.
     */
    sliceIndex: {
      type: Number,
      default: 0
    }
  },
  emits: [
    "focus",
    "click"
  ],
  expose: [
    "root"
  ],
  setup(t, { emit: n }) {
    const l = y(), r = o(() => [
      "or-text-v3",
      ...g
    ]), c = o(() => [
      ...F
    ]), a = o(() => [
      ...h
    ]), s = (e) => e && " " + e.slice(1), m = (e) => e && e.slice(0, -1) + " ", u = o(() => {
      if (t.sliceIndex && t.sliceIndex < t.text.length) {
        let e = t.text.slice(0, Math.abs(t.sliceIndex) * -1);
        return e[e.length - 1] === " " && (e = m(e)), e;
      }
      return t.text;
    }), d = o(() => {
      let e = t.text.slice(u.value.length);
      return e[0] === " " && (e = s(e)), e;
    });
    function T(e) {
      n("focus", e);
    }
    function p(e) {
      n("click", e);
    }
    return {
      root: l,
      rootStyles: r,
      mainTextStyles: c,
      restTextStyles: a,
      mainText: u,
      restText: d,
      onFocus: T,
      onClick: p
    };
  }
});
function I(t, n, l, r, c, a) {
  return S(), v("div", {
    ref: "root",
    class: i(t.rootStyles),
    onFocus: n[0] || (n[0] = (...s) => t.onFocus && t.onFocus(...s)),
    onClick: n[1] || (n[1] = (...s) => t.onClick && t.onClick(...s))
  }, [
    x("div", {
      class: i(t.mainTextStyles)
    }, f(t.mainText), 3),
    x("div", {
      class: i(t.restTextStyles)
    }, f(t.restText), 3)
  ], 34);
}
const b = /* @__PURE__ */ C(w, [["render", I]]);
export {
  b as O
};
//# sourceMappingURL=OrText-3zAJU5xf.mjs.map
